import React from 'react'
import classes from './CompanyDetails.module.css'
import { useAppContext } from '../../../Context/AppContext';
import CompanyInfo from './CompanyInfo';
import AuthorizedSignatory from './AuthorizedSignatory/AuthorizedSignatory';
const CompanyDetails = props => {
    const { isEditable, transporterInfo,navigatigAway } = useAppContext();
    

    return (
        <div className={classes['display-flex-row-direction']}>
          <div className={classes['left'] + ' ' + classes['container-style']}>
            <CompanyInfo
              isEditable={isEditable}
              transporterInfo={transporterInfo}
            />
          </div>
          <div className={classes['right'] + ' ' + classes['container-style']}>
            <AuthorizedSignatory
              isEditable={isEditable}
              transporterInfo={transporterInfo}
              navigatigAway={navigatigAway}
            />
          </div>
        </div>
    )
}

export default CompanyDetails
